import { render } from "./ExpenseHeadList.vue?vue&type=template&id=4ff5490c"
import script from "./ExpenseHeadList.vue?vue&type=script&lang=js"
export * from "./ExpenseHeadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__